var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfDestructionDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 353,
    viewBox: "0 0 368 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 132,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_415_4815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 123,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_415_4815)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 123.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_415_4815)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_4815)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_415_4815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.25 157.9H157.983L157.549 160.5H155.653C154.91 160.5 154.242 160.913 153.909 161.578L152.969 163.459C152.868 163.661 152.879 163.9 152.998 164.092C153.116 164.284 153.324 164.4 153.55 164.4H166.55C166.776 164.4 166.984 164.283 167.103 164.091C167.222 163.9 167.233 163.66 167.132 163.459L166.191 161.577C165.858 160.913 165.19 160.5 164.447 160.5H162.551L162.117 157.9H167.85C169.741 157.9 171.1 155.041 171.1 154.65V145.55C171.1 142.195 169.421 141 167.85 141H152.25C150.458 141 149 142.458 149 144.25V154.65C149 156.442 150.458 157.9 152.25 157.9ZM165.028 162.159L165.498 163.1H154.602L155.072 162.159C155.183 161.938 155.406 161.8 155.653 161.8H158.1H162H164.447C164.694 161.8 164.917 161.938 165.028 162.159ZM161.232 160.5H158.867L159.301 157.9H160.799L161.232 160.5ZM167.85 156.6H161.35H158.75H152.25C151.404 156.6 150.689 156.055 150.42 155.3H169.384C168.987 155.909 168.395 156.6 167.85 156.6ZM152.25 142.3H167.85C169.09 142.3 169.8 143.484 169.8 145.55V154H150.3V144.25C150.3 143.175 151.175 142.3 152.25 142.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.05 152.7C162.559 152.7 164.6 150.658 164.6 148.15C164.6 147.469 164.445 146.824 164.175 146.244L165.059 145.36L164.14 144.441L163.446 145.134C162.612 144.196 161.401 143.6 160.05 143.6C157.541 143.6 155.5 145.642 155.5 148.15C155.5 150.658 157.541 152.7 160.05 152.7ZM160.05 144.9C161.043 144.9 161.922 145.358 162.519 146.062L160.05 148.531L158.559 147.041L157.64 147.96L159.59 149.91C159.717 150.036 159.883 150.1 160.05 150.1C160.216 150.1 160.382 150.036 160.509 149.91L163.16 147.259C163.242 147.544 163.3 147.839 163.3 148.15C163.3 149.942 161.842 151.4 160.05 151.4C158.257 151.4 156.8 149.942 156.8 148.15C156.8 146.358 158.257 144.9 160.05 144.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.05 165.049C185.549 165.049 185.096 165.245 184.75 165.556C184.404 165.244 183.951 165.049 183.45 165.049C182.949 165.049 182.496 165.245 182.15 165.556C181.804 165.244 181.351 165.049 180.85 165.049C180.621 165.049 180.404 165.096 180.2 165.169V163.749C180.2 162.674 179.325 161.799 178.25 161.799C177.175 161.799 176.3 162.674 176.3 163.749V168.03L173.891 170.44C173.768 170.561 173.7 170.726 173.7 170.899V176.749C173.7 176.89 173.746 177.027 173.83 177.139L175.78 179.739C175.902 179.903 176.095 179.999 176.3 179.999H187.35C187.709 179.999 188 179.709 188 179.349V171.549V166.999C188 165.924 187.125 165.049 186.05 165.049ZM186.7 178.699H176.625L175 176.533V171.168L176.3 169.868V171.549H177.6V168.299V163.749C177.6 163.39 177.892 163.099 178.25 163.099C178.608 163.099 178.9 163.39 178.9 163.749V166.999V171.549H180.2V166.999C180.2 166.64 180.492 166.349 180.85 166.349C181.208 166.349 181.5 166.64 181.5 166.999V171.549H182.8V166.999C182.8 166.64 183.092 166.349 183.45 166.349C183.808 166.349 184.1 166.64 184.1 166.999V171.549H185.4V166.999C185.4 166.64 185.692 166.349 186.05 166.349C186.408 166.349 186.7 166.64 186.7 166.999V171.549V178.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9 153.35H177.6V157.25H178.9V153.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.291 155.49L181.042 158.74L181.961 159.659L185.211 156.409L184.291 155.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.211 155.49L171.292 156.409L174.541 159.659L175.461 158.74L172.211 155.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35 161.799H183.45V163.099H187.35V161.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05 161.799H169.15V163.099H173.05V161.799Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_415_4815",
    x: 0,
    y: 0,
    width: 368,
    height: 353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_415_4815"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_415_4815",
    result: "effect2_dropShadow_415_4815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_415_4815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_415_4815",
    x: 145,
    y: 141,
    width: 47,
    height: 46.9991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_4815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_4815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_4815",
    x1: 95.8244,
    y1: 53.3182,
    x2: 166.887,
    y2: 66.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_4815",
    x1: 211.029,
    y1: 172.552,
    x2: 145.042,
    y2: 167.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_4815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(147 138)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfDestructionDark);
export default __webpack_public_path__ + "static/media/selfDestructionDark.a768c1bff1e4fd1661b5c6a01a58468f.svg";
export { ForwardRef as ReactComponent };